import { BiometricAuth } from '@aparajita/capacitor-biometric-auth';

export const useCapacitorBiometry = () => {
  const checkBiometry = async () => {
    return await BiometricAuth.checkBiometry();
  };

  const authenticate = async () => {
    return await BiometricAuth.authenticate({
      allowDeviceCredential: true
    });
  };

  return {
    checkBiometry,
    authenticate
  };
};
